module.exports = __webpack_public_path__ + "static/media/logo.12462a89.png";